import React, { useState, useRef } from "react";
import { GANGSTAVERSE } from "@constants/images";
import Gangstabet from "./gangstaverseBlocks/Gangstabet.block";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const li = ["gangstabet", "emeraldCity", "Dao", "Gangwar", "sapphireCity"];
function ProductSection() {
  const ref = useRef<null | HTMLDivElement>(null);
  const [selected, setSelected] = useState({
    cur: "gangstabet",
    prev: "",
  });
  const activiate_selected_item = (e: any) => {
    ref!.current!.scrollIntoView({ block: "nearest", behavior: "smooth" });
    if (e.target.id !== selected.cur) {
      if (
        e.target.id.trim() !== "sapphireCity" &&
        e.target.id.trim() !== "Gangwar"
      ) {
        e.target.classList.toggle("selected-product");
        document
          .getElementById(selected.cur)
          ?.classList.toggle("selected-product");
        let prev = selected.cur;

        setSelected({ cur: e.target.id, prev: prev });
      }
    }
  };
  const onHoverIn = (e: any) => {
    li.map((id) => {
      if (id === e.target.id) {
        e.target.classList.add("hovered");
      } else {
        document.getElementById(id)?.classList.add("not-hovered");
      }
    });
  };
  const onHoverOut = (e: any) => {
    li.map((id) => {
      if (id === e.target.id) {
        e.target.classList.remove("hovered");
        e.target.classList.remove("not-hovered");
      } else {
        document.getElementById(id)?.classList.remove("not-hovered");
        document.getElementById(id)?.classList.remove("hovered");
      }
    });
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tabletlanscape: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="product-container" ref={ref}>
      <div className="product-thumbnails">
        <Carousel
          responsive={responsive}
          containerClass="carousel-container"
          afterChange={(previousSlide, { currentSlide }) => {
            activiate_selected_item({
              target: document.getElementById(li[currentSlide]),
            });
          }}
        >
          <img
            onClick={activiate_selected_item}
            id="gangstabet"
            className="selected-product"
            onMouseEnter={onHoverIn}
            onMouseLeave={onHoverOut}
            src={GANGSTAVERSE.GANGSTABET}
          />
          <img
            onClick={activiate_selected_item}
            id="emeraldCity"
            className=""
            onMouseEnter={onHoverIn}
            onMouseLeave={onHoverOut}
            src={GANGSTAVERSE.EMERALD_CITY}
          />
          <img
            onClick={activiate_selected_item}
            className=""
            id="Dao"
            onMouseEnter={onHoverIn}
            onMouseLeave={onHoverOut}
            src={GANGSTAVERSE.DAO}
          />
          <img
            onClick={activiate_selected_item}
            className=""
            id="Gangwar"
            onMouseEnter={onHoverIn}
            onMouseLeave={onHoverOut}
            src={GANGSTAVERSE.GANGWAR}
          />
          <img
            onClick={activiate_selected_item}
            className=""
            onMouseEnter={onHoverIn}
            onMouseLeave={onHoverOut}
            id="sapphireCity"
            src={GANGSTAVERSE.SAPPHIRE_CITY}
          />
        </Carousel>
      </div>
      <Gangstabet block={selected.cur} />
    </div>
  );
}

export default ProductSection;
